<template>
  <div>
    <eye-laser :title='title' :category='category'></eye-laser>
  </div>
</template>

<script>
  import eyeLaser from './eyeLaser.vue'
  export default{
    data(){
      return{
        title:'激光照射皮肤的职业接触限值',
        category:'激光照射皮肤'
      }
    },
    components:{eyeLaser}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/laserIrradiation.vue